<template>
  <IndexLayout v-if="$route.meta.anonymousAuth && [' /'].indexOf(this.$route.path) < 0"></IndexLayout>

  <v-app v-else>
    <core-toolbar color="primary" dark>
      <template slot="toolbar-avatar">
        <v-avatar style="cursor: pointer" @click="gotoHome" max-height="50px" size="100" class="ml-3" tile>
          <v-img src="assets/imgs/logo-home.svg" width="100%" height="100%" contain data-cy="toolbar-img" />
        </v-avatar>
      </template>

      <template slot="toolbar-title">
        &nbsp;
      </template>
      <template slot="toolbar-drawer">
        &nbsp;
      </template>

      <template slot="toolbar-after-spacer">
        <div class="ml-auto mr-0" v-if="portalBloqueado">
          <v-tooltip bottom max-width="300">
            <template v-slot:activator="{ on }">
              <v-chip color="warning" v-on="on">
                <v-icon small class="mr-2">ph-warning</v-icon>
                Portal Bloqueado
              </v-chip>
            </template>
            <span data-cy="tooltip-text">Não é possível realizar inclusões e alterações de dados!</span>
          </v-tooltip>
        </div>
      </template>
    </core-toolbar>

    <v-main>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <slot name="footer">
      <v-footer inset app color="primary">
        <v-row class="justify-center">
          <span class="px-4 secondary--text">&copy; {{ new Date().getFullYear() }} - Wiwap</span>
        </v-row>
      </v-footer>
    </slot>
  </v-app>
</template>

<style lang="sass">
  @import 'assets/styles/styles.scss'
</style>

<script>
export default {
  components: {
    IndexLayout: () => import('@bmp-vue/core/layouts/IndexLayout')
  },
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    }
  },
  computed: {
    portalBloqueado () {
      return JSON.parse(localStorage.empresa).portalIndicadorBloqueio
    }
  }
}
</script>
